module.exports = __webpack_public_path__ + "img/avatar1.4c3f23b1.png";